import {useContext} from 'react';

import {OmicronContext} from '@web-landing/components/OmicronClientContext/OmicronClientContext';

export const useOmicron = () => useContext(OmicronContext);
